/* Rhody Reviews api/v1 -- automations domain. PURE EXTRACTION from lib/api.ts (gate-prep split); no behavior change. */
import { request } from './_http';

/* Automations (GET/POST/PUT /automations). */
export type AutomationTrigger =
  | 'job_completed'
  | 'new_5star'
  | 'new_low_rating'
  | 'no_review_after_3d'
  | 'quarterly_winback'
  | 'custom';
export interface Automation {
  id: string;
  trigger: AutomationTrigger | string;
  action: string;
  config: Record<string, unknown>;
  enabled: boolean;
  [k: string]: unknown;
}
export interface AutomationsResponse {
  client_id: string;
  count: number;
  automations: Automation[];
}
export interface AutomationUpdate {
  enabled?: boolean;
  action?: string;
  config?: Record<string, unknown>;
  trigger?: AutomationTrigger | string;
}

export const automationsApi = {
  /* ----- Automations ----- */
  listAutomations(signal?: AbortSignal): Promise<AutomationsResponse> {
    return request<AutomationsResponse>('/api/v1/automations', { signal });
  },
  createAutomation(input: {
    trigger: AutomationTrigger | string;
    action: string;
    config?: Record<string, unknown>;
    enabled?: boolean;
  }): Promise<{ client_id: string; automation: Automation }> {
    return request<{ client_id: string; automation: Automation }>('/api/v1/automations', {
      method: 'POST',
      body: input,
    });
  },
  updateAutomation(
    id: string,
    patch: AutomationUpdate,
  ): Promise<{ client_id: string; automation: Automation }> {
    return request<{ client_id: string; automation: Automation }>(
      `/api/v1/automations/${encodeURIComponent(id)}`,
      { method: 'PUT', body: patch },
    );
  },
};
